import {
    Container,
    FirstContainer,
    SecondContainer,
    LeftSecondContainer,
    RigthSecondContainer,
    ThirdContainer,
  } from "./style";
  import { useUser } from "../../../providers/UserContext";
  import { useSausage } from "../../../providers/SausageContext";
  import { useFries } from "../../../providers/FriesContext";
  import { useCutChicken } from "../../../providers/CutChickenContext";
  import { useChicken } from "../../../providers/ChickenContext";
import { useEffect, useState } from "react";
  
  const ItemShipping = (props) => {
  
    
  
    const {infoChicken} = useChicken()
    const {infoCutChicken} = useCutChicken()
    const {infoFries} = useFries()
    const {infoSausage} = useSausage()

    function calculatePrecoMedio() {
  
      const mediaSausage = infoSausage?.estoque * infoSausage?.preco
      const mediaFries = infoFries?.estoque * infoFries?.preco
      const mediaChicken = infoChicken?.estoque * infoChicken?.preco
      const mediaCutChicken = infoCutChicken?.estoque * infoCutChicken?.preco
  
      return (mediaSausage + mediaChicken + mediaCutChicken + mediaFries) / 4
  
    }

    return (
      <Container>
        {/* <FirstContainer>
          <h3>Estoque inicial</h3>
          <p>0</p>
          <small>Kg</small>
        </FirstContainer> */}
        <SecondContainer>
          <LeftSecondContainer>
            <h3>
              <img src="./images/ticket.svg" alt="ticket" />
              Peso
            </h3>
            <div>
                <p>{props.peso}</p>
                <small>Kg</small>
            </div>
            
          </LeftSecondContainer>
          <RigthSecondContainer>
            <h3>
              Produtos
              <img src="./images/product_recipe.svg" alt="product_recipe" />
            </h3>
            {props.venda.itens.map((item, key) => {

                return <div key={key} > 
                    <img src={item.produto.produto === 7 ? "./images/sausage_pcp.svg" : item.produto.produto === 8 ? "./images/chicken_pcp.svg" : item.produto.produto === 9 ? "./images/cut_chicken_pcp.svg"  : "./images/fries_pcp.svg" } alt="chicken_pcp" />
                    <small>{item.quantidade} caixas</small>
                </div>
            })}
            {/* <div>
              <img src="./images/sausage_pcp.svg" alt="sausage_pcp" />
              <small>{infoSausage?.estoque} caixas</small>
            </div>
            <div>
              <img src="./images/chicken_pcp.svg" alt="chicken_pcp" />
              <small>{infoCutChicken?.estoque} caixas</small>
            </div>
            <div>
              <img src="./images/cut_chicken_pcp.svg" alt="cut_chicken_pcp" />
              <small>{infoCutChicken?.estoque} caixas</small>
            </div>
            <div>
              <img src="./images/fries_pcp.svg" alt="sausage_pcp" />
              <small>{infoFries?.estoque} caixas</small>
            </div> */}
          </RigthSecondContainer>
        </SecondContainer>
      </Container>
    );
  };
  export default ItemShipping;
  